import { InformationCircleIcon } from '@heroicons/react/24/outline';
import { useState } from 'react';
import ModeToggle from './ModeToggle';
import { useWheel } from '../context/WheelContext';

function Header() {
  const { isSharkMode } = useWheel();
  const [showInstructions, setShowInstructions] = useState(false);

  return (
    <header className="bg-white border-b border-secondary-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center py-4">
          <div className="flex items-center gap-3">
            <img src="/logo.svg" alt="Ruleta Aleatoria" className="h-10 w-10" />
            <div>
              <h1 className="text-xl font-bold text-secondary-900">
                {isSharkMode ? 'Shark Roulette' : 'Ruleta Aleatoria'}
              </h1>
              <p className="text-sm text-secondary-600">
                {isSharkMode 
                  ? 'Selección aleatoria estilo Shark Tank' 
                  : 'Selección aleatoria de participantes'}
              </p>
            </div>
          </div>
          
          <div className="flex items-center gap-4">
            <ModeToggle />
            <button
              onClick={() => setShowInstructions(true)}
              className="flex items-center gap-2 px-4 py-2 text-secondary-700 hover:bg-secondary-50 rounded-lg transition-colors"
            >
              <InformationCircleIcon className="h-5 w-5" />
              <span>Instrucciones</span>
            </button>
          </div>
        </div>
      </div>

      {/* Modal de instrucciones */}
      {showInstructions && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
          <div className="bg-white rounded-xl p-8 max-w-2xl w-full mx-4 relative">
            <button
              onClick={() => setShowInstructions(false)}
              className="absolute top-4 right-4 text-secondary-400 hover:text-secondary-600"
            >
              ×
            </button>
            
            <h2 className="text-2xl font-bold text-secondary-900 mb-6">¿Cómo funciona?</h2>
            
            <div className="space-y-4 text-secondary-600">
              <div className="flex items-start gap-3">
                <div className="w-6 h-6 rounded-full bg-primary-100 text-primary-600 flex items-center justify-center flex-shrink-0">1</div>
                <p>Agrega participantes uno por uno o pega una lista completa de nombres (un nombre por línea).</p>
              </div>
              
              <div className="flex items-start gap-3">
                <div className="w-6 h-6 rounded-full bg-primary-100 text-primary-600 flex items-center justify-center flex-shrink-0">2</div>
                <p>Puedes habilitar o deshabilitar participantes usando el botón de ojo junto a cada nombre.</p>
              </div>
              
              <div className="flex items-start gap-3">
                <div className="w-6 h-6 rounded-full bg-primary-100 text-primary-600 flex items-center justify-center flex-shrink-0">3</div>
                <p>Presiona el botón "Girar Ruleta" para seleccionar un ganador aleatorio entre los participantes activos.</p>
              </div>
              
              <div className="flex items-start gap-3">
                <div className="w-6 h-6 rounded-full bg-primary-100 text-primary-600 flex items-center justify-center flex-shrink-0">4</div>
                <p>El historial de ganadores se guarda automáticamente y puede ser exportado a Excel cuando lo necesites.</p>
              </div>

              <div className="flex items-start gap-3">
                <div className="w-6 h-6 rounded-full bg-primary-100 text-primary-600 flex items-center justify-center flex-shrink-0">5</div>
                <p>Puedes copiar la lista de participantes actual o limpiarla completamente usando los botones correspondientes.</p>
              </div>
            </div>
          </div>
        </div>
      )}
    </header>
  );
}

export default Header; 